import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class LoginPageGuard {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  public canActivate(): boolean | UrlTree {
    if (!this.authService.accessToken && !this.authService.refreshToken) {
      return true;
    }

    return this.router.createUrlTree(['/']);
  }
}
